<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel [selectedIndex]="0">
                <wj-tab>
                    <a>{{ 'user.lane_a' | transloco }}</a>
                    <div class="card">
                        <div class="card-header">
                            {{ 'user.lane_a' | transloco }}
                        </div>
                        <div class="card-body">
                            <div class="row" *ngIf="auctionIdOne == ''">
                                <div class="col-sm-12">
                                    <h3>{{ 'user.no_auction_in_lane' | transloco }}</h3>
                                </div>
                            </div>
                            <div class="row" *ngIf="beforeAuctionOne()">
                                <div class="col-sm-12">
                                    <h3>{{ 'user.auction_starts_at' | transloco: {date: (auctionOne.eventDate|date:'yyyy/MM/dd HH:mm')} }}</h3>
                                </div>
                            </div>
                            <div class="row" *ngIf="itemOne.id">
                                <div class="col-sm-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row xs-none">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.event_date' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemOne.auction.eventDate|date:'yyyy/MM/dd HH:mm'}}
                                                </div>
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.lane' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemOne.auction.lane}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-3 col-md-3 form-control-label">{{ 'user.item_id' | transloco }}</label>
                                                <div class="col-3 col-md-3">
                                                    {{itemOne.id}}
                                                </div>
                                                <label class="col-3 col-md-3 form-control-label">{{ 'user.item_category' | transloco }}</label>
                                                <div class="col-3 col-md-3">
                                                    {{itemOne.category}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.item_name' | transloco }}</label>
                                                <div class="col-6 col-md-9">
                                                    {{itemOne.name}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.item_description' | transloco }}</label>
                                                <div class="col-6 col-md-9">
                                                    {{itemOne.description}}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <gallery #imageGalleryOne id="galleryOne" style="max-height: 350px; width: 100%;" [items]="galleryItemsOne" thumbPosition="right"></gallery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row">
                                                <div class="col-6 col-md-4">
                                                    <h3 *ngIf="screenWidth >= 768">{{statusOne}}</h3>
                                                    <h5 *ngIf="screenWidth < 768">{{statusOne}}</h5>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <h3 *ngIf="screenWidth >= 768">{{countOne| number}}</h3>
                                                    <h5 *ngIf="screenWidth < 768">{{countOne| number}}</h5>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <h3 *ngIf="screenWidth >= 768 && user['@rid']==buyerOne">{{ 'user.you_are_current_winner' | transloco }}</h3>
                                                    <h5 *ngIf="screenWidth < 768 && user['@rid']==buyerOne">{{ 'user.you_are_current_winner' | transloco }}</h5>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.current_price' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{ 'user.yen_amount' | transloco: {amount: (priceOne | number)} }}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.quantity' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemOne.quantity}}{{itemOne.unit}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.start_price' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemOne.startPrice|number}}
                                                </div>
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.bid_count' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{bidsOne|number}}
                                                </div>
                                            </div>
                                            <div class="form-group row xs-none">
                                                <div class="col-md-4">
                                                    <button *ngIf="statusOne=='スタート'" (click)="bidOne(250)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '250'} }}</button>
                                                </div>
                                                <div class="col-md-4">
                                                    <button *ngIf="statusOne=='スタート'" (click)="bidOne(1000)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '1,000'} }}</button>
                                                </div>
                                                <div class="col-md-4">
                                                    <button *ngIf="statusOne=='スタート'" (click)="bidOne(10000)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '10,000'} }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="nextItemIdOne != ''">
                                <div class="col-sm-12 xs-margin-bottom">
                                    <div class="card">
                                        <div class="card-header">
                                            {{ 'user.next_item' | transloco }}
                                        </div>
                                        <div class="card-body">
                                            <div class="row" *ngIf="itemOne.id">
                                                <div class="col-6 col-sm-2">
                                                    <div class="row">
                                                        <img *ngIf="nextItemOne.images && nextItemOne.images.length > 0" [src]="getImageSrc(nextItemOne, nextItemOne.images[0])" style="max-height: 250px; max-width: 250px; width: 100%;"/>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-sm-10">
                                                    <div class="form-group row">
                                                        <label class="col-6 col-md-2 form-control-label">{{ 'user.item_id' | transloco }}</label>
                                                        <div class="col-6 col-md-2">
                                                            {{nextItemOne.id}}
                                                        </div>
                                                        <label class="col-6 col-md-2 form-control-label">{{ 'user.quantity' | transloco }}</label>
                                                        <div class="col-6 col-md-2">
                                                            {{nextItemOne.quantity}}{{nextItemOne.unit}}
                                                        </div>
                                                        <label class="col-6 col-md-2 form-control-label">{{ 'user.start_price' | transloco }}</label>
                                                        <div class="col-6 col-md-2">
                                                            {{nextItemOne.startPrice|number}}
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col-6 col-md-3 form-control-label">{{ 'user.item_name' | transloco }}</label>
                                                        <div class="col-6 col-md-9">
                                                            {{nextItemOne.name}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 xs-fixed-bottom">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row">
                                                <div class="col-md-4">
                                                    <button *ngIf="statusOne=='スタート'" (click)="bidOne(250)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '250'} }}</button>
                                                </div>
                                                <div class="col-md-4">
                                                    <button *ngIf="statusOne=='スタート'" (click)="bidOne(1000)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '1,000'} }}</button>
                                                </div>
                                                <div class="col-md-4">
                                                    <button *ngIf="statusOne=='スタート'" (click)="bidOne(10000)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '10,000'} }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>{{ 'user.lane_b' | transloco }}</a>
                    <div class="card">
                        <div class="card-header">
                            {{ 'user.lane_b' | transloco }}
                        </div>
                        <div class="card-body">
                            <div class="row" *ngIf="auctionIdTwo == ''">
                                <div class="col-sm-12">
                                    <h3>{{ 'user.no_auction_in_lane' | transloco }}</h3>
                                </div>
                            </div>
                            <div class="row" *ngIf="beforeAuctionTwo()">
                                <div class="col-sm-12">
                                    <h3>{{ 'user.auction_starts_at' | transloco: {date: (auctionTwo.eventDate|date:'yyyy/MM/dd HH:mm')} }}</h3>
                                </div>
                            </div>
                            <div class="row" *ngIf="itemTwo.id">
                                <div class="col-sm-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row xs-none">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.event_date' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemTwo.auction.eventDate|date:'yyyy/MM/dd HH:mm'}}
                                                </div>
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.lane' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemTwo.auction.lane}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-3 col-md-3 form-control-label">{{ 'user.item_id' | transloco }}</label>
                                                <div class="col-3 col-md-3">
                                                    {{itemTwo.id}}
                                                </div>
                                                <label class="col-3 col-md-3 form-control-label">{{ 'user.item_category' | transloco }}</label>
                                                <div class="col-3 col-md-3">
                                                    {{itemTwo.category}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.item_name' | transloco }}</label>
                                                <div class="col-6 col-md-9">
                                                    {{itemTwo.name}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.item_description' | transloco }}</label>
                                                <div class="col-6 col-md-9">
                                                    {{itemTwo.description}}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <gallery #imageGalleryTwo id="galleryTwo" style="max-height: 350px; width: 100%;" [items]="galleryItemsTwo" thumbPosition="right"></gallery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row">
                                                <div class="col-6 col-md-4">
                                                    <h3 *ngIf="screenWidth >= 768">{{statusTwo}}</h3>
                                                    <h5 *ngIf="screenWidth < 768">{{statusTwo}}</h5>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <h3 *ngIf="screenWidth >= 768">{{countTwo| number}}</h3>
                                                    <h5 *ngIf="screenWidth < 768">{{countTwo| number}}</h5>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <h3 *ngIf="screenWidth >= 768 && user['@rid']==buyerTwo">{{ 'user.you_are_current_winner' | transloco }}</h3>
                                                    <h5 *ngIf="screenWidth < 768 && user['@rid']==buyerTwo">{{ 'user.you_are_current_winner' | transloco }}</h5>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.current_price' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{ 'user.yen_amount' | transloco: {amount: (priceTwo | number)} }}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.quantity' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemTwo.quantity}}{{itemTwo.unit}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.start_price' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{itemTwo.startPrice|number}}
                                                </div>
                                                <label class="col-6 col-md-3 form-control-label">{{ 'user.bid_count' | transloco }}</label>
                                                <div class="col-6 col-md-3">
                                                    {{bidsTwo|number}}
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-md-4">
                                                    <button *ngIf="statusTwo=='スタート'" (click)="bidTwo(250)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '250'} }}</button>
                                                </div>
                                                <div class="col-md-4">
                                                    <button *ngIf="statusTwo=='スタート'" (click)="bidTwo(1000)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '1,000'} }}</button>
                                                </div>
                                                <div class="col-md-4">
                                                    <button *ngIf="statusTwo=='スタート'" (click)="bidTwo(10000)" class="btn btn-primary btn-block">{{ 'user.yen_amount' | transloco: {amount: '10,000'} }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="nextItemIdTwo != ''">
                                <div class="col-sm-12">
                                    <div class="card">
                                        <div class="card-header">
                                            {{ 'user.next_item' | transloco }}
                                        </div>
                                        <div class="card-body">
                                            <div class="row" *ngIf="itemTwo.id">
                                                <div class="col-6 col-sm-2">
                                                    <div class="row">
                                                        <img *ngIf="nextItemTwo.images && nextItemTwo.images.length > 0" [src]="getImageSrc(nextItemTwo, nextItemTwo.images[0])" style="max-height: 250px; max-width: 250px; width: 100%;"/>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-sm-10">
                                                    <div class="form-group row">
                                                        <label class="col-6 col-md-2 form-control-label">{{ 'user.item_id' | transloco }}</label>
                                                        <div class="col-6 col-md-2">
                                                            {{nextItemTwo.id}}
                                                        </div>
                                                        <label class="col-6 col-md-2 form-control-label">{{ 'user.quantity' | transloco }}</label>
                                                        <div class="col-6 col-md-2">
                                                            {{nextItemTwo.quantity}}{{nextItemTwo.unit}}
                                                        </div>
                                                        <label class="col-6 col-md-3 form-control-label">{{ 'user.start_price' | transloco }}</label>
                                                        <div class="col-6 col-md-3">
                                                            {{nextItemTwo.startPrice|number}}
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col-6 col-md-3 form-control-label">{{ 'user.item_name' | transloco }}</label>
                                                        <div class="col-6 col-md-9">
                                                            {{nextItemTwo.name}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
</div>
